import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import {Column as ColumnModel, Content, Mission as MissionModel} from "../../models/secondary-nav"
import connect from "./connect"

export type SecondaryNavContentProps = {
    columns: ColumnModel[]
    department: string
    englishDepartment: string | null | undefined
    isInSecondaryNav: boolean
    deactivateIndex: () => void
    chevronIcon: string
    text: {arrowIconUrlAltText: string}
    showSecondaryNav: boolean
    hasMissions: boolean
    missions: MissionModel | null
    personalisationContent: Content[] | null
    siteUrl: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    textAlignment: string
}

export const BurgerSecondaryNav = memo(
    ({
        columns,
        department,
        englishDepartment,
        isInSecondaryNav,
        deactivateIndex,
        chevronIcon,
        text,
        showSecondaryNav,
        hasMissions,
        missions,
        personalisationContent,
        siteUrl,
        templating,
        textAlignment,
    }: SecondaryNavContentProps) => {
        const TemplatedComponent = useTemplatedComponent(templating, MANIFEST)
        return (
            <Suspense>
                <TemplatedComponent
                    {...{
                        columns,
                        department,
                        englishDepartment,
                        isInSecondaryNav,
                        deactivateIndex,
                        chevronIcon,
                        text,
                        showSecondaryNav,
                        hasMissions,
                        missions,
                        personalisationContent,
                        siteUrl,
                        textAlignment,
                    }}
                />
            </Suspense>
        )
    },
)
BurgerSecondaryNav.displayName = "BurgerSecondaryNav"

export default connect(BurgerSecondaryNav)
